var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTruckRightUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 436,
    height: 361,
    viewBox: "0 0 436 361",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M121.853 361L23.8252 304.94L336.256 126.949L434.263 182.988L121.853 361Z",
    fill: "#EFECEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M346.084 88.8425L259.462 39.3262L327.044 0.576145L413.665 50.0924L346.084 88.8425Z",
    fill: "url(#paint0_linear_2205_2996)",
    stroke: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M399.582 176.146L392.026 172.543L378.001 162.95L367.774 155.701V150.21L390.311 138.035L401.579 135.777V141.225",
    fill: "#000508"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M388.661 161.431L374.831 153.444C374.136 152.902 373.376 152.468 372.595 152.142H372.573C369.468 150.862 365.669 151.209 361.565 153.488C351.078 159.326 342.567 175.56 342.567 189.755C342.567 197.807 345.303 203.471 349.58 205.815H349.559L365.886 215.169L365.604 211.719L362.52 204.795C362.52 204.795 362.412 204.687 362.238 204.513C372.443 198.393 380.585 182.527 380.585 168.615C380.585 167.096 380.476 165.642 380.302 164.296H382.56L388.705 161.41L388.661 161.431Z",
    fill: "#000F20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M258.456 39.3271V157.438L346.084 207.617V89.5275L258.456 39.3271Z",
    fill: "#222222"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M388.831 162.073C392.87 163.715 395.451 168.104 396.249 174.059C397.046 179.998 396.045 187.385 393.031 194.798C390.017 202.211 385.578 208.201 380.862 211.9C376.134 215.61 371.222 216.954 367.183 215.313C363.144 213.672 360.563 209.283 359.764 203.328C358.968 197.389 359.968 190.002 362.982 182.589C365.997 175.176 370.436 169.186 375.151 165.486C379.879 161.777 384.792 160.432 388.831 162.073Z",
    fill: "#222222",
    stroke: "url(#paint1_linear_2205_2996)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M391.136 181.355C391.136 191.165 385.252 202.386 378.022 206.401C370.77 210.438 364.908 205.75 364.908 195.94C364.908 186.13 370.792 174.909 378.022 170.894C385.274 166.857 391.136 171.545 391.136 181.355Z",
    fill: "url(#paint2_linear_2205_2996)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M388.683 182.722C388.683 190.687 383.907 199.803 378.023 203.08C372.139 206.357 367.362 202.537 367.362 194.572C367.362 186.607 372.139 177.492 378.023 174.214C383.907 170.937 388.683 174.757 388.683 182.722Z",
    fill: "#000F20"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M387.12 183.59C387.12 190.405 383.038 198.175 378.001 200.975C372.964 203.775 368.882 200.519 368.882 193.704C368.882 186.889 372.964 179.119 378.001 176.32C383.038 173.52 387.12 176.775 387.12 183.59Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M384.524 191.341C387.084 185.045 386.241 178.755 382.642 177.293C379.043 175.83 374.05 179.749 371.49 186.045C368.93 192.341 369.772 198.631 373.371 200.093C376.97 201.556 381.963 197.637 384.524 191.341Z",
    fill: "#222222"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M380.702 189.766C381.763 187.157 381.417 184.551 379.928 183.946C378.44 183.341 376.373 184.966 375.312 187.576C374.251 190.185 374.597 192.791 376.086 193.396C377.574 194.001 379.641 192.376 380.702 189.766Z",
    fill: "#D7F0FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M382.125 187.411C382.125 189.755 380.714 192.446 378.977 193.401C377.24 194.356 375.829 193.249 375.829 190.905C375.829 188.561 377.24 185.87 378.977 184.915C380.714 183.96 382.125 185.067 382.125 187.411Z",
    fill: "url(#paint3_linear_2205_2996)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M384.558 179.662C384.688 179.597 384.796 179.51 384.927 179.402C384.427 178.512 383.776 177.839 382.994 177.427C382.929 177.709 382.886 178.013 382.886 178.295C382.886 179.554 383.646 180.161 384.579 179.641L384.558 179.662Z",
    fill: "url(#paint4_linear_2205_2996)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M383.949 191.295C383.016 191.816 382.256 193.27 382.256 194.529C382.256 194.811 382.299 195.071 382.364 195.267C383.233 194.008 383.993 192.597 384.579 191.1C384.384 191.1 384.167 191.165 383.928 191.273L383.949 191.295Z",
    fill: "url(#paint5_linear_2205_2996)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M378 177.839C377.457 178.143 376.915 178.512 376.394 178.946C376.611 179.749 377.24 180.074 378 179.662C378.76 179.25 379.39 178.208 379.607 177.166C379.086 177.318 378.543 177.535 378 177.839Z",
    fill: "url(#paint6_linear_2205_2996)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M384.558 184.241C384.558 185.348 385.144 185.956 385.904 185.738C385.947 185.239 385.991 184.718 385.991 184.219C385.991 183.199 385.882 182.288 385.687 181.463C385.035 182.136 384.558 183.243 384.558 184.241Z",
    fill: "url(#paint7_linear_2205_2996)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M373.506 200.085C373.658 199.673 373.745 199.217 373.745 198.805C373.745 197.546 372.985 196.938 372.051 197.459C371.769 197.611 371.487 197.871 371.27 198.175C371.856 199.109 372.616 199.76 373.528 200.107L373.506 200.085Z",
    fill: "url(#paint8_linear_2205_2996)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M378.001 197.459C377.197 197.915 376.524 199.043 376.351 200.172C376.893 200.02 377.436 199.803 378.001 199.477C378.565 199.152 379.13 198.783 379.651 198.327C379.477 197.394 378.804 197.003 378.001 197.459Z",
    fill: "url(#paint9_linear_2205_2996)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M371.422 192.033C371.422 190.991 370.923 190.427 370.228 190.514C370.098 191.382 370.011 192.25 370.011 193.096C370.011 193.747 370.054 194.377 370.141 194.963C370.879 194.312 371.422 193.096 371.422 192.033Z",
    fill: "url(#paint10_linear_2205_2996)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M372.03 186.238C372.963 185.717 373.723 184.263 373.723 183.004C373.723 182.657 373.658 182.374 373.571 182.136C372.681 183.438 371.921 184.892 371.335 186.433C371.552 186.433 371.791 186.39 372.03 186.259V186.238Z",
    fill: "url(#paint11_linear_2205_2996)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M426.178 88.6161L414.693 49.8535L346.084 89.5276V207.617L352.728 203.797V181.638L361.087 159.76L381.062 148.995L384.709 150.384C393.654 153.814 399.582 162.408 399.582 171.979V176.168L429.652 159.109V112.62C429.652 104.503 428.48 96.4076 426.178 88.6161Z",
    fill: "#D0E1EE"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M378.196 133.065L363.28 141.182C357.005 145.74 352.945 144.264 352.945 137.427V94.4323L403.425 65.2627L412.804 92.9998L412.718 136.429L397.498 144.047C391.831 134.237 378.196 133.086 378.196 133.086V133.065Z",
    fill: "#B1C8DA"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M435.319 113.466L432.67 115.159V76.8738L435.319 75.1592V113.466Z",
    fill: "url(#paint12_linear_2205_2996)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M432.671 76.8523L417.776 68.5182L420.425 66.9121L435.298 75.2463L432.671 76.8523Z",
    fill: "url(#paint13_linear_2205_2996)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M432.671 115.159L417.776 106.825V68.5186L432.671 76.8527V115.159Z",
    fill: "#001208"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M426.07 114.899C425.94 114.899 425.788 114.856 425.657 114.791L414.476 108.236C414.085 108.019 413.933 107.498 414.15 107.108C414.367 106.717 414.888 106.565 415.279 106.782L425.223 112.642V110.189C425.223 109.734 425.592 109.365 426.048 109.365C426.504 109.365 426.873 109.734 426.873 110.189V114.074C426.873 114.378 426.721 114.639 426.461 114.791C426.33 114.856 426.178 114.899 426.048 114.899H426.07Z",
    fill: "#001208"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M426.07 72.707C425.614 72.707 425.245 72.338 425.245 71.8822V67.9756L413.824 61.573C413.434 61.356 413.282 60.8351 413.499 60.4444C413.716 60.0538 414.237 59.9019 414.628 60.1189L426.482 66.7602C426.743 66.9121 426.917 67.1942 426.917 67.4764V71.8822C426.917 72.338 426.548 72.707 426.092 72.707H426.07Z",
    fill: "#001208"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M403.056 174.54L406.53 176.385L432.518 157.481L435.992 138.404L429.652 134.193V138.209L403.056 153.596V174.54Z",
    fill: "url(#paint14_linear_2205_2996)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M406.529 176.386L435.992 159.348V138.404L406.529 155.442V176.386Z",
    fill: "#222222"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M345.064 20.5535L320.009 35.0514V33.1415L345.064 14.1943V20.5535Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M320.009 33.1197L311.216 28.0411L336.271 9.18066L345.043 14.2593L320.009 33.1197Z",
    fill: "#222222"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M320.009 35.0513L311.216 29.9726V28.041L320.009 33.1196V35.0513Z",
    fill: "#222222"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M369.099 33.5759L344.044 48.0739V46.164L369.099 27.2168V33.5759Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M344.044 46.1421L335.251 41.0635L360.306 22.2031L369.078 27.2817L344.044 46.1421Z",
    fill: "#222222"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M344.044 48.0737L335.251 42.9951V41.0635L344.044 46.1421V48.0737Z",
    fill: "#222222"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M393.133 46.5974L368.078 61.0954V59.1855L393.133 40.2383V46.5974Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M368.078 59.1636L359.285 54.085L384.34 35.2246L393.134 40.3032L368.078 59.1636Z",
    fill: "#222222"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M368.078 61.0952L359.285 56.0166V54.085L368.078 59.1636V61.0952Z",
    fill: "#222222"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M284.402 196.113V200.02L248.187 179.315V175.386L227.474 163.536L224.369 165.533L227.474 180.899L302.032 227.301L305.115 225.326V207.963L284.402 196.113Z",
    fill: "#000F20"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M281.319 198.089V202.017L245.082 181.29V177.383L224.369 165.533V182.896L302.032 227.301V209.939L281.319 198.089Z",
    fill: "#001E33"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M334.85 180.4L334.965 180.466H334.985C339.258 182.975 341.893 187.548 341.893 192.489V192.49L341.936 208.216L294.438 235.363L288.757 219.837L288.734 219.774L288.695 219.718L274.861 200.354L322.375 173.271L334.85 180.4Z",
    fill: "#222222",
    stroke: "url(#paint15_linear_2205_2996)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M274.61 224.32V201.055L284.067 206.466L284.067 206.466C289.99 209.849 293.65 216.151 293.65 222.982V235.207L274.61 224.32Z",
    fill: "#222222",
    stroke: "url(#paint16_linear_2205_2996)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M247.513 241.3C247.513 241.3 255.329 244.534 255.633 256.298L250.314 253.498L242.498 247.247L236.961 243.927L234.508 240.693C237.309 236.005 247.513 241.3 247.513 241.3Z",
    fill: "url(#paint17_linear_2205_2996)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M245.168 243.557L231.338 235.57C230.643 235.028 229.883 234.594 229.102 234.268H229.08C225.975 232.988 222.175 233.335 218.072 235.614C207.585 241.452 199.074 257.686 199.074 271.881C199.074 279.933 201.81 285.597 206.087 287.941H206.065L222.393 297.295L222.11 293.845L219.027 286.921C219.027 286.921 218.919 286.813 218.745 286.639C228.949 280.519 237.091 264.653 237.091 250.741C237.091 249.222 236.983 247.768 236.809 246.422H239.067L245.212 243.536L245.168 243.557Z",
    fill: "#020202"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M253.527 260.226C253.527 274.42 245.016 290.676 234.529 296.493C224.042 302.331 215.531 295.538 215.531 281.344C215.531 267.149 224.042 250.893 234.529 245.077C245.016 239.239 253.527 246.032 253.527 260.226Z",
    fill: "#222222"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M247.644 263.481C247.644 273.291 241.76 284.512 234.53 288.527C227.278 292.564 221.416 287.876 221.416 278.066C221.416 268.256 227.3 257.035 234.53 253.02C241.782 248.983 247.644 253.671 247.644 263.481Z",
    fill: "url(#paint18_linear_2205_2996)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M245.19 264.849C245.19 272.814 240.413 281.93 234.53 285.207C228.646 288.484 223.869 284.664 223.869 276.699C223.869 268.734 228.646 259.618 234.53 256.341C240.413 253.064 245.19 256.884 245.19 264.849Z",
    fill: "#000F20"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M243.626 265.716C243.626 272.531 239.545 280.301 234.508 283.101C229.47 285.901 225.389 282.645 225.389 275.83C225.389 269.015 229.47 261.245 234.508 258.446C239.545 255.646 243.626 258.901 243.626 265.716Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M242.519 266.346C242.519 272.315 238.936 279.152 234.529 281.604C230.122 284.057 226.539 281.213 226.539 275.223C226.539 269.233 230.122 262.418 234.529 259.966C238.936 257.513 242.519 260.356 242.519 266.346Z",
    fill: "#222222"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M237.83 268.95C237.83 271.424 236.353 274.246 234.53 275.266C232.706 276.286 231.229 275.092 231.229 272.618C231.229 270.144 232.706 267.322 234.53 266.302C236.353 265.282 237.83 266.476 237.83 268.95Z",
    fill: "#D7F0FF"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M238.633 269.537C238.633 271.881 237.222 274.572 235.485 275.527C233.748 276.482 232.337 275.375 232.337 273.031C232.337 270.687 233.748 267.996 235.485 267.041C237.222 266.086 238.633 267.193 238.633 269.537Z",
    fill: "url(#paint19_linear_2205_2996)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M241.086 261.788C241.216 261.723 241.325 261.636 241.455 261.528C240.956 260.638 240.304 259.965 239.523 259.553C239.457 259.835 239.414 260.139 239.414 260.421C239.414 261.68 240.174 262.287 241.108 261.767L241.086 261.788Z",
    fill: "url(#paint20_linear_2205_2996)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M240.456 273.421C239.523 273.942 238.763 275.396 238.763 276.655C238.763 276.937 238.806 277.197 238.871 277.393C239.74 276.134 240.5 274.723 241.086 273.226C240.89 273.226 240.673 273.291 240.435 273.399L240.456 273.421Z",
    fill: "url(#paint21_linear_2205_2996)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M234.507 259.965C233.964 260.269 233.421 260.638 232.9 261.072C233.118 261.875 233.747 262.2 234.507 261.788C235.267 261.376 235.897 260.334 236.114 259.292C235.593 259.444 235.05 259.661 234.507 259.965Z",
    fill: "url(#paint22_linear_2205_2996)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M241.086 266.345C241.086 267.452 241.672 268.06 242.432 267.843C242.475 267.344 242.519 266.823 242.519 266.324C242.519 265.304 242.41 264.392 242.215 263.567C241.564 264.24 241.086 265.347 241.086 266.345Z",
    fill: "url(#paint23_linear_2205_2996)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M230.013 282.211C230.165 281.799 230.252 281.343 230.252 280.931C230.252 279.672 229.492 279.064 228.558 279.585C228.276 279.737 227.993 279.997 227.776 280.301C228.363 281.235 229.123 281.886 230.034 282.233L230.013 282.211Z",
    fill: "url(#paint24_linear_2205_2996)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M234.508 279.564C233.704 280.019 233.031 281.148 232.857 282.276C233.4 282.125 233.943 281.908 234.508 281.582C235.072 281.256 235.637 280.887 236.158 280.432C235.984 279.498 235.311 279.108 234.508 279.564Z",
    fill: "url(#paint25_linear_2205_2996)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M227.929 274.159C227.929 273.117 227.429 272.553 226.735 272.64C226.604 273.508 226.518 274.376 226.518 275.222C226.518 275.873 226.561 276.503 226.648 277.089C227.386 276.438 227.929 275.222 227.929 274.159Z",
    fill: "url(#paint26_linear_2205_2996)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M228.537 268.364C229.47 267.843 230.23 266.389 230.23 265.13C230.23 264.783 230.165 264.5 230.078 264.262C229.188 265.564 228.428 267.018 227.842 268.559C228.059 268.559 228.298 268.516 228.537 268.385V268.364Z",
    fill: "url(#paint27_linear_2205_2996)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M194.515 272.299L194.532 272.602L194.809 272.727L212.395 280.67L213.089 280.984L213.101 280.222L213.101 280.221L213.101 280.218L213.101 280.203L213.103 280.14C213.104 280.085 213.107 280.001 213.111 279.89C213.12 279.67 213.135 279.344 213.163 278.924C213.219 278.086 213.323 276.876 213.519 275.396C213.909 272.436 214.662 268.403 216.109 264.11C219.007 255.514 224.659 245.957 235.683 241.789L235.684 241.789L235.684 241.789L235.684 241.789L235.686 241.788L235.697 241.784C235.708 241.78 235.724 241.774 235.746 241.766C235.791 241.751 235.857 241.727 235.945 241.698C236.121 241.64 236.381 241.559 236.712 241.468C237.374 241.286 238.317 241.068 239.433 240.922C241.674 240.63 244.577 240.636 247.32 241.783L247.717 240.865L237.469 236.286L237.238 236.182L237.017 236.308L197.089 259.14L196.975 259.206L196.907 259.319L197.338 259.574C196.907 259.319 196.907 259.32 196.907 259.32L196.907 259.32L196.906 259.322L196.904 259.326L196.896 259.339C196.89 259.35 196.881 259.365 196.87 259.385C196.847 259.426 196.816 259.484 196.776 259.56C196.696 259.712 196.585 259.935 196.454 260.227C196.192 260.811 195.851 261.668 195.525 262.779C194.873 264.999 194.284 268.231 194.515 272.299Z",
    fill: "#222222",
    stroke: "url(#paint28_linear_2205_2996)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M199.964 268.603C199.964 268.603 207.78 271.837 208.084 283.6L202.765 280.801L194.949 274.55L189.412 271.229L186.959 267.995C189.76 263.308 199.964 268.603 199.964 268.603Z",
    fill: "url(#paint29_linear_2205_2996)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M197.619 270.86L183.789 262.873C183.094 262.331 182.334 261.897 181.553 261.571H181.531C178.426 260.29 174.627 260.638 170.523 262.917C160.036 268.755 151.525 284.989 151.525 299.183C151.525 307.235 154.261 312.9 158.538 315.244H158.517L174.844 324.598L174.561 321.147L171.478 314.224C171.478 314.224 171.37 314.115 171.196 313.942C181.401 307.821 189.543 291.956 189.543 278.044C189.543 276.525 189.434 275.071 189.26 273.725H191.518L197.663 270.838L197.619 270.86Z",
    fill: "#020202"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M202.475 304.393C208.557 289.436 206.553 274.493 198 271.018C189.446 267.542 177.582 276.85 171.5 291.808C165.418 306.765 167.421 321.708 175.975 325.183C184.528 328.659 196.393 319.351 202.475 304.393Z",
    fill: "#222222"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M200.095 290.784C200.095 300.594 194.211 311.815 186.981 315.83C179.729 319.867 173.867 315.179 173.867 305.369C173.867 295.559 179.751 284.338 186.981 280.323C194.233 276.286 200.095 280.974 200.095 290.784Z",
    fill: "url(#paint30_linear_2205_2996)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M197.641 292.151C197.641 300.116 192.865 309.232 186.981 312.509C181.097 315.786 176.32 311.966 176.32 304.001C176.32 296.036 181.097 286.92 186.981 283.643C192.865 280.366 197.641 284.186 197.641 292.151Z",
    fill: "#020202"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M196.078 293.019C196.078 299.834 191.996 307.604 186.959 310.404C181.922 313.203 177.84 309.948 177.84 303.133C177.84 296.318 181.922 288.548 186.959 285.748C191.996 282.949 196.078 286.204 196.078 293.019Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M193.504 300.748C196.064 294.452 195.222 288.162 191.623 286.7C188.024 285.238 183.031 289.156 180.47 295.452C177.91 301.749 178.753 308.038 182.352 309.5C185.951 310.963 190.944 307.044 193.504 300.748Z",
    fill: "#222222"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M189.661 299.173C190.722 296.564 190.376 293.958 188.887 293.353C187.399 292.748 185.332 294.374 184.271 296.983C183.21 299.593 183.556 302.198 185.045 302.803C186.533 303.408 188.6 301.783 189.661 299.173Z",
    fill: "#D7F0FF"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M191.106 296.84C191.106 299.184 189.695 301.875 187.958 302.83C186.221 303.785 184.81 302.678 184.81 300.334C184.81 297.99 186.221 295.299 187.958 294.344C189.695 293.389 191.106 294.496 191.106 296.84Z",
    fill: "url(#paint31_linear_2205_2996)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M193.537 289.091C193.667 289.026 193.776 288.939 193.906 288.831C193.407 287.941 192.755 287.268 191.974 286.855C191.909 287.138 191.865 287.441 191.865 287.724C191.865 288.982 192.625 289.59 193.559 289.069L193.537 289.091Z",
    fill: "url(#paint32_linear_2205_2996)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M192.929 300.724C191.995 301.245 191.235 302.699 191.235 303.958C191.235 304.24 191.279 304.5 191.344 304.695C192.212 303.437 192.972 302.026 193.558 300.528C193.363 300.528 193.146 300.593 192.907 300.702L192.929 300.724Z",
    fill: "url(#paint33_linear_2205_2996)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M186.98 287.268C186.437 287.571 185.894 287.94 185.373 288.374C185.59 289.177 186.22 289.503 186.98 289.091C187.74 288.678 188.369 287.636 188.586 286.595C188.065 286.747 187.522 286.964 186.98 287.268Z",
    fill: "url(#paint34_linear_2205_2996)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M193.537 293.648C193.537 294.755 194.123 295.363 194.883 295.146C194.927 294.647 194.97 294.126 194.97 293.626C194.97 292.606 194.861 291.695 194.666 290.87C194.015 291.543 193.537 292.65 193.537 293.648Z",
    fill: "url(#paint35_linear_2205_2996)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M182.464 309.514C182.616 309.102 182.703 308.646 182.703 308.233C182.703 306.975 181.943 306.367 181.009 306.888C180.727 307.04 180.445 307.3 180.228 307.604C180.814 308.537 181.574 309.188 182.486 309.536L182.464 309.514Z",
    fill: "url(#paint36_linear_2205_2996)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M186.98 306.888C186.177 307.343 185.504 308.472 185.33 309.601C185.873 309.449 186.416 309.232 186.98 308.906C187.545 308.581 188.109 308.212 188.63 307.756C188.457 306.823 187.783 306.432 186.98 306.888Z",
    fill: "url(#paint37_linear_2205_2996)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M180.401 301.462C180.401 300.42 179.902 299.856 179.207 299.942C179.077 300.81 178.99 301.679 178.99 302.525C178.99 303.176 179.034 303.806 179.12 304.392C179.859 303.74 180.401 302.525 180.401 301.462Z",
    fill: "url(#paint38_linear_2205_2996)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M181.009 295.666C181.943 295.146 182.703 293.691 182.703 292.433C182.703 292.085 182.638 291.803 182.551 291.564C181.661 292.867 180.901 294.321 180.314 295.862C180.532 295.862 180.77 295.818 181.009 295.688V295.666Z",
    fill: "url(#paint39_linear_2205_2996)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M146.966 299.602L146.984 299.905L147.26 300.029L164.846 307.973L165.541 308.286L165.552 307.525L165.552 307.524L165.552 307.521L165.552 307.505L165.554 307.443C165.555 307.387 165.558 307.303 165.562 307.193C165.571 306.973 165.587 306.646 165.614 306.227C165.67 305.389 165.775 304.179 165.97 302.699C166.36 299.738 167.113 295.705 168.56 291.413C171.458 282.817 177.11 273.259 188.135 269.092L188.135 269.092L188.135 269.092L188.135 269.092L188.137 269.091L188.149 269.087C188.159 269.083 188.175 269.077 188.198 269.069C188.242 269.054 188.309 269.03 188.397 269.001C188.572 268.943 188.833 268.862 189.163 268.771C189.825 268.589 190.768 268.371 191.884 268.225C194.125 267.933 197.028 267.939 199.772 269.086L200.168 268.168L189.92 263.588L189.689 263.485L189.468 263.611L149.541 286.443L149.426 286.509L149.359 286.622L149.789 286.877C149.359 286.622 149.359 286.622 149.358 286.623L149.358 286.623L149.357 286.624L149.355 286.628L149.347 286.641C149.341 286.652 149.332 286.668 149.321 286.688C149.299 286.728 149.267 286.787 149.227 286.863C149.148 287.015 149.036 287.238 148.905 287.53C148.644 288.113 148.302 288.971 147.976 290.081C147.325 292.302 146.735 295.534 146.966 299.602Z",
    fill: "#222222",
    stroke: "url(#paint40_linear_2205_2996)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M125.033 290.467V294.373L88.796 273.646V269.74L68.1048 257.89L65 259.886L68.1048 275.252L142.641 321.655L145.746 319.68V302.317L125.033 290.467Z",
    fill: "url(#paint41_linear_2205_2996)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M121.928 292.442V296.37L85.713 275.644V271.715L65 259.887V277.25L142.641 321.655V304.292L121.928 292.442Z",
    fill: "#222222"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M338.238 63.1703V175.716L108.254 307.174V194.628L338.238 63.1703Z",
    fill: "#222222",
    stroke: "url(#paint42_linear_2205_2996)",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M337.205 65.7834V175.538L109.536 305.651V195.896L337.205 65.7834ZM341.373 58.5127L105.367 193.4V312.835L341.373 177.947V58.5127Z",
    fill: "#222222"
  }))), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M105.391 189.924L13.4112 137.323L243.342 6.2757L335.301 58.856L105.391 189.924Z",
    fill: "#222222",
    stroke: "url(#paint43_linear_2205_2996)",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M243.344 7.61779L332.97 58.8599L105.388 188.582L15.7625 137.34L243.344 7.61779ZM243.344 2.82129L7.38184 137.318L105.388 193.357L341.351 58.8599L243.344 2.82129Z",
    fill: "#222222"
  }))), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M102.389 195.119V307.642L10.3604 255.013V142.49L102.389 195.119Z",
    fill: "#222222",
    stroke: "url(#paint44_linear_2205_2996)",
    strokeWidth: 6
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M11.529 144.502L101.22 195.809V305.651L11.529 254.344V144.502ZM7.36035 137.318V256.753L105.367 312.813V193.379L7.36035 137.318Z",
    fill: "#91ABFF"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M11.529 144.502L101.22 195.809V305.651L11.529 254.344V144.502ZM7.36035 137.318V256.753L105.367 312.813V193.379L7.36035 137.318Z",
    fill: "#222222"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M369.924 125.88V89.7872L397.715 73.3359L405.488 97.5137L405.835 104.698L369.924 125.88Z",
    fill: "#161C21"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M370.857 131.22L379.911 126.293V123.559L370.857 128.485V131.22Z",
    fill: "black"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M75.535 289.959L71.6921 292.433L75.535 294.821L30.5267 269.08V264.219L3.92989 248.939L0.0869141 251.392L4.79835 271.077L105.28 332.997L109.123 330.892V308.971L75.535 289.959Z",
    fill: "url(#paint45_linear_2205_2996)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M71.692 292.412V297.273L26.6837 271.533V266.671L0 251.436V273.009L105.28 332.998V311.424L71.692 292.412Z",
    fill: "#222222"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1792 324.142L82.2441 314.593V305.607L99.1792 315.179V324.142Z",
    fill: "url(#paint46_linear_2205_2996)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8411 281.885L5.92773 272.336V263.351L22.8411 272.922V281.885Z",
    fill: "url(#paint47_linear_2205_2996)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6731 126.975L116.562 141.921L110.701 145.304L99.5545 138.869L88.9832 144.972L100.13 151.407L94.2688 154.79L68.3799 139.845L74.2408 136.461L84.0211 142.107L94.5925 136.005L84.8122 130.358L90.6731 126.975Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M132.203 121.764C138.172 125.21 137.812 130.192 131.556 133.804C125.263 137.437 116.669 137.624 110.701 134.178C104.768 130.753 105.055 125.771 111.348 122.138C117.604 118.526 126.27 118.339 132.203 121.764ZM126.414 125.106C122.315 122.74 119.079 122.906 115.878 124.754C112.642 126.622 112.391 128.469 116.49 130.836C120.625 133.223 123.789 133.057 127.025 131.189C130.225 129.341 130.549 127.494 126.414 125.106Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M149.499 117.675L154.03 120.29L153.131 120.809C148.097 123.715 142.56 123.882 138.065 121.287L116.203 108.666L121.776 105.449L143.458 117.966C145.616 119.211 146.982 119.128 148.888 118.028L149.499 117.675Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M181.106 82.4068L198.006 92.163C204.514 95.9202 205.018 99.8227 197.323 104.265C191.57 107.586 186.284 107.524 181.07 106.092L186.428 102.999C188.585 103.58 190.563 103.061 192.972 101.67C196.676 99.532 197.251 98.162 193.08 95.7541L191.498 94.8408C192.109 96.3561 191.678 97.8091 188.37 99.7189C183.444 102.563 174.886 102.936 169.42 99.7811C163.811 96.5429 164.027 91.7271 169.277 88.6964C172.441 86.8697 175.641 86.7244 178.05 87.0773L175.533 85.6243L181.106 82.4068ZM183.228 90.0665C179.884 89.0908 177.798 88.9663 174.454 90.8968C171.722 92.4744 171.578 94.3426 175.21 96.4391C179.273 98.7848 182.149 98.5357 184.954 96.9166C188.55 94.8408 188.226 93.6161 186.248 91.8101L183.228 90.0665Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M198.581 72.2369L203.759 75.226C202.932 75.4128 201.925 75.828 200.846 76.4507C197.682 78.2774 197.071 80.374 201.134 82.7196L210.123 87.9091L204.55 91.1266L185.277 80.0003L190.85 76.7828L193.655 78.402C192.612 76.6791 193.403 74.7693 195.992 73.2748C196.819 72.7973 197.79 72.4029 198.581 72.2369Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M235.33 68.1268L239.86 70.7423L239.033 71.2197C235.869 73.0464 233.891 73.2333 231.554 72.8389C232.345 74.2919 230.835 76.4923 227.707 78.2982C223.751 80.5816 217.926 81.661 213.612 79.17C209.369 76.7206 211.958 73.1087 216.093 70.7215C217.561 69.8429 219.374 69.1809 221.378 68.7911L219.94 67.9608C217.711 66.6738 216.093 66.57 213.396 68.1268C211.526 69.2062 210.843 69.9328 211.778 71.0122L206.348 74.1466C203.436 70.8876 204.982 68.0853 209.117 65.6981C214.942 62.3354 220.911 62.0863 225.729 64.8678L231.734 68.3344C232.992 69.0609 233.927 68.9364 234.862 68.3967L235.33 68.1268ZM224.974 70.8669C223.32 71.0329 222.026 71.3235 219.76 72.6313C217.459 73.9598 217.423 74.7693 219.113 75.745C220.695 76.6583 222.097 76.6376 224.183 75.4336C226.34 74.1881 227.203 73.3578 226.844 71.9463L224.974 70.8669Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M227.095 44.8561L231.589 47.4508C230.308 47.8577 229.133 48.3679 228.102 48.9662C226.412 49.9418 226.196 50.9797 228.245 52.1629L230.87 53.6782L236.264 50.5645L240.794 53.18L235.401 56.2937L250.143 64.8044L244.57 68.0219L229.827 59.5112L226.016 61.7115L221.485 59.096L225.297 56.8957L222.636 55.3596C218.393 52.9102 218.609 49.2152 222.672 46.8696C223.998 46.0966 225.483 45.4204 227.095 44.8561Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M166.607 101.191C172.372 104.519 171.952 109.373 165.809 112.919C159.63 116.486 151.258 116.709 145.493 113.381C139.763 110.073 140.113 105.219 146.293 101.652C152.439 98.1058 160.877 97.8832 166.607 101.191Z",
    fill: "#222222",
    stroke: "url(#paint48_radial_2205_2996)",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M164.046 109.846C166.94 108.175 168.89 106.039 169.632 103.728C171.865 106.709 170.524 110.2 165.811 112.92C163.529 114.238 160.944 115.098 158.305 115.493C158.175 114.843 158.303 114.181 158.68 113.559C159.058 112.937 159.675 112.37 160.484 111.901L164.046 109.846ZM160.543 107.824L156.982 109.88C155.67 110.637 154.661 111.55 154.028 112.553C153.394 113.556 153.152 114.624 153.318 115.68C154.152 115.742 154.996 115.757 155.838 115.724C155.651 114.851 155.815 113.961 156.318 113.123C156.82 112.285 157.647 111.522 158.736 110.892L162.297 108.836C165.569 106.948 167.439 104.402 167.5 101.753C167.22 101.561 166.926 101.375 166.611 101.193C166.061 100.875 165.469 100.582 164.84 100.317C165.2 101.666 164.998 103.049 164.251 104.354C163.504 105.66 162.233 106.849 160.543 107.824ZM151.788 102.77C152.26 102.497 152.528 102.129 152.533 101.747C152.539 101.365 152.282 101 151.818 100.732L150.351 99.8847C148.86 100.359 147.493 100.955 146.293 101.654C141.778 104.26 140.379 107.552 142.183 110.426C143.428 108.322 145.497 106.406 148.227 104.827L151.788 102.77ZM155.291 104.791C156.641 104.009 157.436 102.966 157.516 101.871C157.596 100.776 156.955 99.7115 155.721 98.8915C154.738 98.9549 153.769 99.0785 152.828 99.2603L153.598 99.7043C154.525 100.241 155.039 100.972 155.028 101.736C155.017 102.501 154.481 103.236 153.539 103.782L149.979 105.837C146.919 107.602 144.792 109.831 143.853 112.256C144.343 112.658 144.892 113.035 145.495 113.382C145.646 113.469 145.794 113.554 145.953 113.634C146.513 111.074 148.549 108.684 151.731 106.848L155.291 104.791ZM155.232 108.869L158.793 106.813C160.457 105.851 161.628 104.643 162.171 103.326C162.715 102.01 162.61 100.638 161.868 99.3663C160.88 99.1395 159.844 98.9853 158.785 98.9071C159.829 99.9971 160.223 101.26 159.908 102.504C159.594 103.748 158.587 104.906 157.041 105.802L153.48 107.858C150.333 109.676 148.483 112.106 148.304 114.655C149.088 114.931 149.92 115.159 150.787 115.336C150.719 114.147 151.079 112.958 151.843 111.845C152.608 110.732 153.762 109.719 155.232 108.869Z",
    fill: "url(#paint49_radial_2205_2996)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M166.607 101.191C172.372 104.519 171.952 109.373 165.809 112.919C159.63 116.486 151.258 116.709 145.493 113.381C139.763 110.073 140.113 105.219 146.293 101.652C152.439 98.1058 160.877 97.8832 166.607 101.191Z",
    stroke: "url(#paint50_radial_2205_2996)",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M254.373 48.7539C258.792 47.0374 264.291 45.1568 268.592 47.6402C273.183 50.2905 270.288 53.84 265.731 56.471C260.384 59.5579 255.38 60.0256 250.074 58.1223L255.349 55.0769C257.081 55.6627 258.451 55.7488 261.286 54.1121C263.726 52.7034 264.441 51.8316 263.248 51.1429C261.874 50.3499 261.083 50.5146 257.382 51.9415C253.178 53.5753 247.177 55.6627 242.766 53.1167C238.682 50.7586 240.857 47.3739 245.523 44.6807C250.331 41.9046 255.514 41.3333 260.316 43.0692L255.04 46.1146C253.309 45.6951 252.228 45.7344 249.968 47.0396C247.563 48.4277 247.244 49.1963 248.365 49.8432C249.413 50.4484 250.6 50.2222 254.373 48.7539Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.904 208.463L225.064 203.532C233.767 199.683 242.145 193.283 249.193 185.106C247.771 189.589 245.638 193.917 242.902 197.936C237.368 206.02 229.392 212.868 219.917 217.057C212.914 220.149 206.608 221.153 201.398 220.272C202.821 217.768 204.614 215.45 206.669 213.456C208.895 211.292 211.384 209.591 213.919 208.463H213.904Z",
    fill: "url(#paint51_linear_2205_2996)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.959 151.085C248.158 154.269 252.007 160.946 252.362 170.592C252.718 180.237 249.518 190.099 243.752 198.539C237.987 206.979 229.701 214.059 219.948 218.371C210.194 222.684 201.584 223.086 195.401 219.932C189.203 216.764 185.4 210.07 185.029 200.379C184.658 190.687 187.842 180.948 193.608 172.493C199.358 164.038 207.659 156.943 217.459 152.599C227.259 148.256 235.761 147.947 241.959 151.115V151.085ZM251.095 174.951C251.172 173.683 251.187 172.4 251.141 171.117C250.786 161.812 247.107 155.444 241.171 152.398C235.22 149.369 226.996 149.678 217.505 153.851C207.968 158.071 199.992 164.934 194.474 173.034C190.285 179.202 187.502 186.111 186.575 193.16C186.281 195.37 186.173 197.581 186.266 199.791C186.266 200.131 186.297 200.456 186.312 200.796C186.467 203.13 186.838 205.279 187.394 207.226C187.951 209.143 188.693 210.859 189.62 212.374C190.517 213.842 191.583 215.125 192.789 216.223C193.825 217.15 194.968 217.923 196.205 218.557C196.39 218.649 196.576 218.742 196.761 218.819C198.184 219.484 199.729 219.963 201.399 220.242C206.608 221.123 212.915 220.133 219.917 217.026C229.408 212.837 237.384 205.99 242.902 197.905C245.638 193.886 247.771 189.558 249.193 185.076C250.245 181.752 250.894 178.352 251.095 174.935",
    fill: "url(#paint52_linear_2205_2996)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.038 170.312L252.919 169.926L252.95 170.869L252.069 171.255L252.038 170.312Z",
    fill: "url(#paint53_linear_2205_2996)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.687 181.427C244.046 177.099 247.802 172.013 250.662 166.557C250.925 167.994 251.079 169.509 251.141 171.117C251.187 172.4 251.172 173.667 251.095 174.95C244.154 185.198 234.772 193.345 224.832 197.75L213.672 202.681C210.271 204.18 206.933 206.499 203.934 209.42C201.105 212.156 198.647 215.387 196.746 218.849C196.561 218.757 196.375 218.679 196.19 218.587C194.953 217.953 193.809 217.165 192.773 216.253C195.185 212.079 198.215 208.199 201.677 204.922C205.325 201.46 209.344 198.708 213.44 196.9L224.6 191.969C229.933 189.619 235.081 186.018 239.672 181.442L239.687 181.427Z",
    fill: "url(#paint54_linear_2205_2996)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.471 196.884C209.375 198.693 205.356 201.444 201.708 204.907C198.246 208.199 195.216 212.064 192.805 216.237C191.599 215.155 190.532 213.872 189.636 212.388C192.542 207.766 196.051 203.531 199.992 199.93C204.135 196.142 208.664 193.128 213.255 191.103L224.415 186.172C229.64 183.854 234.679 180.082 238.992 175.259C243.088 170.684 246.349 165.351 248.467 159.802C249.487 161.765 250.229 164.022 250.678 166.572C247.802 172.029 244.062 177.114 239.703 181.442C235.112 186.018 229.964 189.619 224.709 191.938L213.487 196.9L213.471 196.884Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.431 169.756C240.986 165.258 243.552 160.064 244.773 154.917C246.226 156.262 247.463 157.885 248.452 159.802C246.334 165.351 243.073 170.684 238.976 175.259C234.664 180.082 229.609 183.853 224.4 186.172L213.24 191.103C208.633 193.143 204.12 196.142 199.977 199.929C196.035 203.531 192.511 207.766 189.62 212.388C188.693 210.873 187.951 209.157 187.395 207.241C194.273 197.394 203.409 189.573 213.023 185.322L224.183 180.391C229.037 178.227 233.69 174.502 237.431 169.756Z",
    fill: "url(#paint55_linear_2205_2996)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.182 180.393L213.022 185.324C203.408 189.575 194.272 197.396 187.394 207.243C186.837 205.295 186.466 203.162 186.312 200.812C193.793 191.306 203.098 183.824 212.806 179.527L223.966 174.596C228.201 172.71 232.22 169.248 235.188 164.873C237.986 160.746 239.702 156.14 239.98 151.843C240.382 152.013 240.784 152.198 241.17 152.384C242.484 153.064 243.69 153.899 244.772 154.888C243.551 160.035 240.985 165.214 237.43 169.727C233.673 174.473 229.036 178.213 224.182 180.362V180.393Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.02 200.13L185.757 193.298L186.932 192.772L187.194 199.62L186.02 200.13Z",
    fill: "url(#paint56_linear_2205_2996)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.447 152.321L234.385 150.497C236.41 150.698 238.28 151.146 239.98 151.857C239.98 151.966 239.965 152.089 239.949 152.197C239.949 152.367 239.919 152.476 239.919 152.584C239.903 152.785 239.888 152.878 239.872 152.986C239.841 153.202 239.826 153.295 239.826 153.388C239.795 153.619 239.779 153.712 239.764 153.805C239.733 154.037 239.702 154.13 239.687 154.222C239.64 154.454 239.625 154.547 239.609 154.64C239.563 154.872 239.548 154.964 239.517 155.057C239.455 155.304 239.439 155.382 239.424 155.474C239.424 155.521 239.393 155.583 239.393 155.629C239.378 155.722 239.347 155.799 239.331 155.892C239.331 155.938 239.3 156 239.285 156.046C239.254 156.139 239.238 156.232 239.208 156.309C239.146 156.556 239.115 156.649 239.084 156.726C239.007 156.974 238.991 157.067 238.96 157.159C238.883 157.391 238.852 157.484 238.821 157.592C238.728 157.855 238.651 158.087 238.558 158.319C238.497 158.504 238.466 158.581 238.435 158.674C238.419 158.736 238.388 158.798 238.373 158.844C238.342 158.921 238.311 158.999 238.28 159.076C238.249 159.138 238.234 159.215 238.203 159.277C238.172 159.354 238.141 159.416 238.11 159.493C238.079 159.555 238.048 159.632 238.017 159.694C237.986 159.772 237.955 159.833 237.925 159.911C237.894 159.988 237.863 160.05 237.832 160.127C237.801 160.189 237.77 160.266 237.739 160.328C237.708 160.405 237.677 160.467 237.646 160.544C237.615 160.606 237.585 160.684 237.554 160.745C237.523 160.823 237.492 160.885 237.445 160.962C237.414 161.024 237.384 161.101 237.353 161.163C237.322 161.24 237.275 161.317 237.244 161.379C237.214 161.441 237.183 161.518 237.136 161.58C237.105 161.657 237.059 161.735 237.028 161.797C236.997 161.858 236.966 161.92 236.92 161.997C236.873 162.075 236.843 162.152 236.796 162.229C236.765 162.291 236.734 162.353 236.688 162.415C236.642 162.492 236.611 162.569 236.564 162.647C236.533 162.709 236.487 162.77 236.456 162.832C236.41 162.909 236.363 162.987 236.317 163.064C236.286 163.126 236.24 163.188 236.209 163.25C236.162 163.327 236.116 163.404 236.07 163.481C236.039 163.543 235.992 163.59 235.961 163.651C235.915 163.729 235.853 163.821 235.807 163.899C235.776 163.945 235.745 164.007 235.714 164.053C235.652 164.146 235.606 164.223 235.544 164.316C235.359 164.594 235.281 164.718 235.189 164.857C232.221 169.216 228.202 172.694 223.966 174.58L212.806 179.511C212.651 179.573 212.497 179.65 212.342 179.712C212.095 179.82 211.987 179.866 211.879 179.928C211.817 179.959 211.755 179.99 211.693 180.006C211.6 180.052 211.508 180.098 211.415 180.129C211.338 180.16 211.26 180.206 211.199 180.237C211.121 180.268 211.044 180.315 210.967 180.346C210.889 180.376 210.812 180.423 210.735 180.454C210.657 180.485 210.58 180.531 210.503 180.562C210.426 180.593 210.348 180.639 210.271 180.67C210.194 180.701 210.116 180.747 210.039 180.778C209.962 180.809 209.885 180.856 209.807 180.902C209.73 180.948 209.653 180.979 209.575 181.026C209.498 181.072 209.421 181.103 209.344 181.149C209.266 181.196 209.189 181.227 209.112 181.273C209.034 181.319 208.957 181.35 208.88 181.397C208.803 181.428 208.741 181.474 208.663 181.505C208.586 181.551 208.493 181.598 208.416 181.644C208.354 181.675 208.277 181.721 208.215 181.752C208.138 181.799 208.061 181.845 207.983 181.891C207.906 181.938 207.844 181.969 207.767 182.015C207.69 182.061 207.612 182.108 207.52 182.154C207.458 182.2 207.38 182.231 207.319 182.278C207.241 182.324 207.149 182.371 207.071 182.432C207.01 182.463 206.948 182.51 206.886 182.541C206.793 182.587 206.716 182.649 206.623 182.695C206.561 182.726 206.499 182.772 206.438 182.803C206.345 182.85 206.252 182.912 206.175 182.958C206.113 182.989 206.051 183.035 206.005 183.066C205.912 183.128 205.819 183.174 205.742 183.236C205.68 183.267 205.618 183.313 205.556 183.344C205.464 183.406 205.371 183.453 205.294 183.514C205.232 183.545 205.17 183.592 205.124 183.623C205.031 183.684 204.938 183.731 204.845 183.793C204.784 183.824 204.737 183.87 204.675 183.901C204.583 183.963 204.49 184.024 204.397 184.086C204.335 184.117 204.289 184.164 204.227 184.194C204.134 184.256 204.042 184.318 203.949 184.38C203.903 184.411 203.841 184.457 203.794 184.488C203.702 184.55 203.609 184.612 203.516 184.674C203.47 184.705 203.423 184.736 203.362 184.766C203.269 184.828 203.161 184.906 203.068 184.967C203.021 184.998 202.975 185.029 202.929 185.06C202.836 185.122 202.728 185.199 202.635 185.261C202.589 185.292 202.542 185.323 202.496 185.354C202.388 185.431 202.295 185.493 202.187 185.57C201.955 185.725 201.862 185.802 201.754 185.879C201.538 186.034 201.429 186.111 201.321 186.189C201.105 186.343 200.997 186.42 200.888 186.513C200.672 186.668 200.564 186.76 200.456 186.838C200.255 186.992 200.146 187.07 200.023 187.162C199.837 187.317 199.714 187.394 199.59 187.487C199.404 187.626 199.281 187.734 199.157 187.827C199.003 187.951 198.863 188.059 198.74 188.167C195.37 190.872 192.186 193.933 189.218 197.287C189.094 197.426 188.971 197.565 188.847 197.704C188.723 197.859 188.6 197.998 188.476 198.137C188.352 198.292 188.229 198.431 188.105 198.57C187.981 198.725 187.858 198.864 187.749 199.003C187.626 199.157 187.502 199.297 187.394 199.436C187.255 199.59 187.147 199.729 187.038 199.868C186.899 200.038 186.791 200.178 186.683 200.317C186.559 200.471 186.436 200.626 186.327 200.765C186.296 200.44 186.281 200.116 186.266 199.776C186.188 197.565 186.296 195.339 186.575 193.144C187.301 192.341 188.028 191.552 188.77 190.779C188.893 190.64 189.017 190.517 189.141 190.393C189.28 190.254 189.388 190.13 189.512 190.022C189.651 189.883 189.774 189.759 189.883 189.651C190.022 189.512 190.145 189.388 190.254 189.28C190.408 189.125 190.516 189.017 190.64 188.909C190.795 188.754 190.903 188.646 191.026 188.538C191.181 188.399 191.289 188.291 191.413 188.167C191.567 188.028 191.691 187.904 191.799 187.796C191.954 187.657 192.062 187.549 192.186 187.425C192.325 187.286 192.449 187.178 192.572 187.07C192.711 186.946 192.835 186.822 192.959 186.714C193.098 186.59 193.221 186.467 193.345 186.359C193.484 186.235 193.608 186.127 193.747 186.003C195.71 184.256 197.735 182.633 199.791 181.149C199.915 181.057 200.038 180.979 200.162 180.887C200.332 180.763 200.456 180.686 200.564 180.593C200.749 180.469 200.857 180.392 200.966 180.315C201.151 180.176 201.259 180.114 201.368 180.036C201.584 179.882 201.677 179.82 201.785 179.758C202.001 179.604 202.109 179.542 202.202 179.48C202.419 179.325 202.527 179.264 202.62 179.202C202.666 179.171 202.712 179.14 202.759 179.109C202.851 179.047 202.944 178.985 203.037 178.923C203.083 178.893 203.13 178.862 203.176 178.831C203.269 178.769 203.362 178.707 203.454 178.645C203.501 178.614 203.562 178.583 203.609 178.552C203.702 178.491 203.794 178.444 203.872 178.382C203.933 178.352 203.98 178.305 204.042 178.274C204.134 178.228 204.212 178.166 204.304 178.12C204.366 178.089 204.428 178.042 204.474 178.011C204.552 177.965 204.645 177.903 204.722 177.857C204.784 177.826 204.845 177.78 204.892 177.749C204.969 177.702 205.062 177.641 205.139 177.594C205.201 177.563 205.263 177.517 205.325 177.486C205.402 177.44 205.495 177.393 205.572 177.331C205.634 177.3 205.696 177.254 205.757 177.223C205.835 177.177 205.927 177.13 206.005 177.084C206.067 177.053 206.128 177.007 206.19 176.976C206.268 176.929 206.36 176.883 206.438 176.837C206.499 176.806 206.561 176.759 206.623 176.729C206.7 176.682 206.778 176.636 206.855 176.589C206.917 176.543 206.994 176.512 207.056 176.481C207.133 176.435 207.21 176.404 207.288 176.358C207.35 176.327 207.427 176.28 207.489 176.249C207.566 176.203 207.643 176.157 207.721 176.126C207.782 176.095 207.86 176.048 207.921 176.017C207.999 175.971 208.076 175.925 208.153 175.894C208.215 175.863 208.292 175.817 208.354 175.786C208.432 175.739 208.509 175.708 208.586 175.662C208.663 175.631 208.725 175.585 208.803 175.554C208.88 175.507 208.957 175.476 209.034 175.43C209.112 175.399 209.174 175.353 209.251 175.322C209.328 175.291 209.405 175.245 209.467 175.214C209.545 175.183 209.606 175.136 209.684 175.105C209.761 175.075 209.838 175.028 209.9 174.997C209.977 174.966 210.055 174.92 210.116 174.889C210.194 174.858 210.256 174.812 210.333 174.781C210.41 174.734 210.487 174.704 210.58 174.657C210.642 174.626 210.719 174.595 210.781 174.564C210.858 174.518 210.951 174.487 211.028 174.441C211.09 174.41 211.168 174.379 211.229 174.348C211.307 174.317 211.384 174.271 211.461 174.24C211.523 174.209 211.6 174.178 211.662 174.147C211.755 174.101 211.863 174.054 211.956 174.008C212.002 173.993 212.049 173.962 212.095 173.946C212.25 173.884 212.389 173.807 212.543 173.745L223.688 168.814C226.656 167.5 229.438 165.027 231.448 161.936C233.457 158.844 234.524 155.382 234.416 152.306L234.447 152.321Z",
    fill: "url(#paint57_linear_2205_2996)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.734 168.83L212.589 173.761C203.284 177.873 194.272 184.597 186.574 193.191C186.976 190.115 187.734 187.055 188.816 184.087C196.096 177.131 204.134 171.628 212.373 167.98L223.533 163.049C225.017 162.4 226.408 161.148 227.398 159.618C228.402 158.072 228.943 156.341 228.881 154.795L228.727 150.621C230.721 150.374 232.607 150.343 234.384 150.513L234.446 152.337C234.57 155.398 233.488 158.86 231.478 161.967C229.469 165.059 226.687 167.532 223.719 168.846L223.734 168.83Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.475 173.05C199.993 164.935 207.969 158.087 217.506 153.867C221.494 152.105 225.251 151.038 228.713 150.605L228.868 154.779C228.93 156.325 228.389 158.041 227.384 159.602C226.379 161.132 224.988 162.384 223.519 163.033L212.359 167.964C212.096 168.088 211.834 168.196 211.571 168.32C211.478 168.366 211.401 168.397 211.308 168.443C211.138 168.521 210.968 168.598 210.782 168.691C210.674 168.737 210.566 168.784 210.473 168.845C210.319 168.923 210.164 169 210.009 169.077C209.901 169.139 209.778 169.185 209.669 169.247C209.515 169.325 209.376 169.402 209.221 169.464C209.113 169.525 208.989 169.587 208.881 169.634C208.742 169.711 208.587 169.788 208.448 169.85C208.325 169.912 208.201 169.974 208.093 170.036C207.954 170.113 207.815 170.175 207.675 170.252C207.552 170.314 207.428 170.391 207.304 170.453C207.165 170.53 207.026 170.592 206.903 170.669C206.779 170.731 206.655 170.808 206.532 170.87C206.392 170.948 206.269 171.025 206.13 171.087C206.006 171.164 205.882 171.226 205.743 171.303C205.62 171.38 205.48 171.458 205.357 171.535C205.233 171.612 205.094 171.69 204.97 171.767C204.847 171.844 204.723 171.921 204.584 171.999C204.46 172.076 204.321 172.153 204.197 172.231C204.074 172.308 203.95 172.385 203.826 172.462C203.687 172.54 203.564 172.617 203.425 172.71C203.301 172.787 203.177 172.864 203.054 172.942C202.914 173.019 202.791 173.112 202.652 173.189C202.528 173.266 202.404 173.344 202.281 173.421C202.142 173.514 202.018 173.591 201.879 173.684C201.755 173.761 201.647 173.838 201.523 173.915C201.384 174.008 201.261 174.085 201.121 174.178C200.998 174.255 200.89 174.333 200.766 174.41C200.627 174.503 200.488 174.596 200.364 174.688C200.256 174.766 200.132 174.843 200.024 174.92C199.885 175.013 199.746 175.106 199.607 175.198C199.498 175.276 199.39 175.353 199.267 175.43C199.127 175.523 198.988 175.631 198.849 175.724C198.741 175.801 198.633 175.879 198.525 175.956C198.385 176.064 198.246 176.157 198.092 176.265C197.984 176.342 197.875 176.42 197.783 176.497C197.643 176.605 197.489 176.713 197.35 176.821C197.257 176.899 197.149 176.976 197.056 177.038C196.902 177.146 196.762 177.27 196.608 177.378C196.515 177.44 196.438 177.517 196.345 177.579C196.19 177.703 196.036 177.826 195.866 177.95C195.789 178.012 195.711 178.074 195.634 178.135C195.464 178.274 195.294 178.398 195.139 178.537C195.078 178.584 195.016 178.63 194.954 178.692C194.768 178.831 194.598 178.986 194.413 179.125C194.382 179.156 194.351 179.186 194.305 179.202C193.176 180.129 192.048 181.088 190.95 182.077C190.672 182.324 190.487 182.494 190.301 182.664C190.255 182.711 190.208 182.742 190.162 182.788C189.992 182.943 189.807 183.113 189.636 183.267C189.575 183.329 189.513 183.375 189.451 183.437C189.281 183.592 189.126 183.746 188.956 183.901C188.91 183.947 188.848 183.994 188.802 184.056C190.193 180.222 192.094 176.512 194.459 173.034L194.475 173.05Z",
    fill: "url(#paint58_linear_2205_2996)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.847 197.75C234.786 193.36 244.169 185.199 251.109 174.95C250.908 178.382 250.244 181.782 249.208 185.09C242.16 193.267 233.766 199.667 225.079 203.516L213.919 208.447C211.384 209.575 208.895 211.275 206.669 213.439C204.613 215.433 202.836 217.752 201.398 220.256C199.729 219.978 198.183 219.499 196.761 218.834C198.677 215.356 201.135 212.141 203.949 209.405C206.947 206.484 210.286 204.18 213.687 202.666L224.847 197.735V197.75Z",
    fill: "#151515"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2205_2996",
    x1: 268.785,
    y1: 99.0323,
    x2: 407.563,
    y2: 7.56226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2205_2996",
    x1: 387.268,
    y1: 219.841,
    x2: 375.083,
    y2: 158.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2205_2996",
    x1: 366.642,
    y1: 211.979,
    x2: 397.984,
    y2: 203.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2205_2996",
    x1: 376.245,
    y1: 194.73,
    x2: 383.765,
    y2: 192.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2205_2996",
    x1: 383.021,
    y1: 180.085,
    x2: 385.379,
    y2: 179.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2205_2996",
    x1: 382.409,
    y1: 195.715,
    x2: 385.244,
    y2: 195.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2205_2996",
    x1: 376.606,
    y1: 180.128,
    x2: 380.003,
    y2: 178.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2205_2996",
    x1: 384.652,
    y1: 186.246,
    x2: 386.45,
    y2: 186.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2205_2996",
    x1: 371.433,
    y1: 200.412,
    x2: 374.278,
    y2: 199.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2205_2996",
    x1: 376.569,
    y1: 200.484,
    x2: 380.121,
    y2: 198.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2205_2996",
    x1: 370.104,
    y1: 195.442,
    x2: 371.877,
    y2: 195.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2205_2996",
    x1: 371.493,
    y1: 186.895,
    x2: 374.408,
    y2: 186.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2205_2996",
    x1: 432.845,
    y1: 119.459,
    x2: 436.218,
    y2: 119.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2205_2996",
    x1: 418.935,
    y1: 77.921,
    x2: 434.416,
    y2: 67.6258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2205_2996",
    x1: 405.233,
    y1: 180.921,
    x2: 443.855,
    y2: 169.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2205_2996",
    x1: 278.648,
    y1: 242.907,
    x2: 353.347,
    y2: 212.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2205_2996",
    x1: 275.435,
    y1: 239.926,
    x2: 299.886,
    y2: 234.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2205_2996",
    x1: 235.905,
    y1: 258.184,
    x2: 258.219,
    y2: 248.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2205_2996",
    x1: 223.15,
    y1: 294.105,
    x2: 254.492,
    y2: 286.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2205_2996",
    x1: 232.753,
    y1: 276.856,
    x2: 240.272,
    y2: 274.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2205_2996",
    x1: 239.549,
    y1: 262.211,
    x2: 241.907,
    y2: 261.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2205_2996",
    x1: 238.916,
    y1: 277.841,
    x2: 241.751,
    y2: 277.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2205_2996",
    x1: 233.113,
    y1: 262.254,
    x2: 236.51,
    y2: 260.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2205_2996",
    x1: 241.181,
    y1: 268.351,
    x2: 242.979,
    y2: 268.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2205_2996",
    x1: 227.94,
    y1: 282.538,
    x2: 230.785,
    y2: 281.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2205_2996",
    x1: 233.076,
    y1: 282.589,
    x2: 236.628,
    y2: 281.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2205_2996",
    x1: 226.611,
    y1: 277.568,
    x2: 228.384,
    y2: 277.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2205_2996",
    x1: 228,
    y1: 269.021,
    x2: 230.915,
    y2: 268.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2205_2996",
    x1: 198.438,
    y1: 284.888,
    x2: 253.873,
    y2: 259.607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2205_2996",
    x1: 188.356,
    y1: 285.486,
    x2: 210.67,
    y2: 275.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2205_2996",
    x1: 175.601,
    y1: 321.408,
    x2: 206.943,
    y2: 313.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2205_2996",
    x1: 185.226,
    y1: 304.159,
    x2: 192.745,
    y2: 302.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2205_2996",
    x1: 192,
    y1: 289.514,
    x2: 194.358,
    y2: 288.758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2205_2996",
    x1: 191.389,
    y1: 305.143,
    x2: 194.224,
    y2: 304.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2205_2996",
    x1: 185.586,
    y1: 289.557,
    x2: 188.983,
    y2: 288.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2205_2996",
    x1: 193.632,
    y1: 295.654,
    x2: 195.43,
    y2: 295.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2205_2996",
    x1: 180.391,
    y1: 309.84,
    x2: 183.236,
    y2: 308.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2205_2996",
    x1: 185.548,
    y1: 309.913,
    x2: 189.1,
    y2: 308.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2205_2996",
    x1: 179.084,
    y1: 304.871,
    x2: 180.857,
    y2: 304.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2205_2996",
    x1: 180.472,
    y1: 296.324,
    x2: 183.388,
    y2: 295.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2205_2996",
    x1: 150.89,
    y1: 312.191,
    x2: 206.324,
    y2: 286.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2205_2996",
    x1: 70.339,
    y1: 328.51,
    x2: 154.113,
    y2: 288.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2205_2996",
    x1: 120.857,
    y1: 339.689,
    x2: 388.749,
    y2: 245.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2205_2996",
    x1: 29.4441,
    y1: 213.866,
    x2: 325.568,
    y2: 18.0517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_2205_2996",
    x1: 13.8421,
    y1: 331.681,
    x2: 133.448,
    y2: 306.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_2205_2996",
    x1: 7.29648,
    y1: 342.035,
    x2: 119.395,
    y2: 287.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_2205_2996",
    x1: 83.3639,
    y1: 326.135,
    x2: 102.652,
    y2: 319.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_2205_2996",
    x1: 7.04606,
    y1: 283.878,
    x2: 26.3151,
    y2: 277.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_2205_2996",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(158.204 100.064) rotate(-65.3154) scale(38.5801 30.3739)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_2205_2996",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(158.206 100.065) rotate(-65.3157) scale(38.5802 30.3741)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_2205_2996",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(158.204 100.064) rotate(-65.3154) scale(38.5801 30.3739)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_2205_2996",
    x1: 204.559,
    y1: 224.392,
    x2: 252.957,
    y2: 199.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_2205_2996",
    x1: 189.456,
    y1: 229.848,
    x2: 266.041,
    y2: 203.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_2205_2996",
    x1: 252.098,
    y1: 171.398,
    x2: 253.188,
    y2: 171.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_2205_2996",
    x1: 196.634,
    y1: 224.472,
    x2: 259.83,
    y2: 197.848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_2205_2996",
    x1: 191.432,
    y1: 218.567,
    x2: 258.468,
    y2: 191.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_2205_2996",
    x1: 185.852,
    y1: 200.921,
    x2: 187.674,
    y2: 200.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_2205_2996",
    x1: 189.794,
    y1: 206.169,
    x2: 248.693,
    y2: 182.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_2205_2996",
    x1: 191.451,
    y1: 187.652,
    x2: 233.853,
    y2: 168.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckRightUp);
export default __webpack_public_path__ + "static/media/truck-right-up.473ca8bf9808cd1c84179662c5af5dc1.svg";
export { ForwardRef as ReactComponent };